import type { Locale } from '@skytech/types'
import { getFormattedNumberWithCurrency } from '@skytech/utils'

import { DEFAULT_LOCALE } from '@/app-constants'
import { useProfile } from '@/hooks/user'

export const useFormattedNumberWithCurrency = () => {
  const profile = useProfile()

  const formatNumber = ({
    amount,
    currency,
    locale,
    precision,
  }: {
    amount: number
    currency?: Intl.NumberFormatOptions['currency'] | null
    locale?: Locale
    precision?: number
  }) =>
    getFormattedNumberWithCurrency({
      amount,
      precision,
      locale: locale || profile?.locale || DEFAULT_LOCALE,
      currency: currency || profile?.currency,
    })

  return { formatNumber }
}
